import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, InputNumber, Upload, Select, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { getDirectusClient } from '../../../lib/directus';
import { createItem, readItems, uploadFiles } from '@directus/sdk';

const { Dragger } = Upload;
const { Option } = Select;

const ConsignacionModal = ({ visible, onCancel, currentCajaId }) => {
  const [form] = Form.useForm();
  const [bancos, setBancos] = useState([]);
  const [fileId, setFileId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBancos();
  }, []);

  const fetchBancos = async () => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems('bancos', {
          fields: ['id', 'nombre']
        })
      );
      setBancos(response);
    } catch (error) {
      console.error('Error fetching bancos:', error);
      message.error('Error al cargar los bancos');
    }
  };

  const handleFileUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const directus = await getDirectusClient();
      const response = await directus.request(uploadFiles(formData));

      if (response.id) {
        setFileId(response.id);
        message.success('Evidencia subida correctamente');
      }
      return false; // Prevent default upload behavior
    } catch (error) {
      console.error('Error uploading file:', error);
      message.error('Error al subir la evidencia');
      return false;
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (!fileId) {
        message.error('Por favor suba una evidencia');
        return;
      }

      const directus = await getDirectusClient();
      const consignacionData = {
        nombre: values.nombre,
        monto: values.monto,
        caja: currentCajaId,
        evidencia: fileId,
        referencia: values.referencia,
        banco: values.banco,
        tipo: 'caja',
        liquidacion: null
      };

      await directus.request(
        createItem('consignaciones', consignacionData)
      );

      message.success('Consignación creada exitosamente');
      form.resetFields();
      setFileId(null);
      onCancel();
    } catch (error) {
      console.error('Error creating consignacion:', error);
      message.error('Error al crear la consignación');
    } finally {
      setLoading(false);
    }
  };

  const uploadProps = {
    name: 'file',
    multiple: false,
    accept: 'image/*',
    beforeUpload: handleFileUpload,
    showUploadList: true,
  };

  return (
    <Modal
      title="Nueva Consignación"
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[{ required: true, message: 'Por favor ingrese el nombre' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="monto"
          label="Monto"
          rules={[{ required: true, message: 'Por favor ingrese el monto' }]}
        >
          <InputNumber
            style={{ width: '100%' }}
            min={0}
            precision={2}
            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>

        <Form.Item
          name="referencia"
          label="Referencia"
          rules={[{ required: true, message: 'Por favor ingrese la referencia' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="banco"
          label="Banco"
          rules={[{ required: true, message: 'Por favor seleccione el banco' }]}
        >
          <Select placeholder="Seleccione un banco">
            {bancos.map(banco => (
              <Option key={banco.id} value={banco.id}>
                {banco.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Evidencia"
          required
          tooltip="Suba una imagen como evidencia"
        >
          <Dragger {...uploadProps}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click o arrastre una imagen para subirla
            </p>
            <p className="ant-upload-hint">
              Solo se permiten archivos de imagen
            </p>
          </Dragger>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ConsignacionModal;